import type { DateRange } from 'react-day-picker';

import { fromIsoDate, toIsoDate } from '@pesto/utils';
import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { DateRangePicker } from '../../../../components/DateRangePicker';
import { useQueryString } from '../../hooks/useQueryString';

export const DateRangeFilter = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const { createQueryString } = useQueryString(searchParams);
  const from = searchParams.get('from');
  const to = searchParams.get('to');

  const initialDateValue: DateRange = {
    from: from ? fromIsoDate(from) : undefined,
    to: to ? fromIsoDate(to) : undefined,
  };

  const [dateValue, setDateValue] = useState<DateRange | undefined>(initialDateValue);

  const handleDateChange = (date: DateRange | undefined) => {
    setDateValue(date);
    const fromDate = date?.from ? toIsoDate(date.from) : null;
    const toDate = date?.to ? toIsoDate(date.to) : null;
    navigate(`${pathname}?${createQueryString({ from: fromDate, to: toDate })}`, { replace: true });
  };

  return <DateRangePicker dateValue={dateValue} onDateChange={handleDateChange} enablePresetOptions />;
};
